import apiUrls from "api/urls";
import { type Dispatch, useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";
import { customApiCall } from "utils/axios";

import type { SubmitInfoAction } from "../types";

import { SingleBuildingContext } from "../../../context/AddSingleBuildingContext";

type DeleteResult = {
  index: number;
  reason?: unknown;
  status: "fulfilled" | "rejected";
  url: string;
  value?: unknown;
};

export const useDeleteImages = (projectId: string | undefined, dispatch: Dispatch<SubmitInfoAction>) => {
  const { t } = useTranslation();
  const { formData } = useContext(SingleBuildingContext);

  return useCallback(() => {
    const imagesToDelete = formData.deletedAPIImages;
    if (!imagesToDelete || !projectId) return;

    const urls = imagesToDelete.map((image) => apiUrls.buildingImage.delete(projectId, image.id));

    customApiCall.deleteAll({
      onEach: (r: DeleteResult) => {
        const errorMessage =
          r.status === "rejected"
            ? typeof r.reason === "string" && r.reason
              ? r.reason
              : (t("AddBuilding.submitModal.error.failedToDeleteImage") as string)
            : "";

        dispatch({
          errorMessage,
          file: imagesToDelete[r.index],
          list: "deletedAPIImages",
          percentage: 0,
          status: r.status === "fulfilled" ? "completed" : "error",
          type: "UPSERT_UPLOAD_ROW",
        });
      },
      urls,
    });
  }, [formData.deletedAPIImages, projectId, t, dispatch]);
};
